import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorToast, Hub } from '../../../components';
import { CaptionText, H2, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { PurchaseSteps, UserAddress } from '../Maeketplace.types';
import { CheckText } from '../../../components/common/CheckText';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { UserInfoType } from '../../../types/loginTypes';

import euroVat from '../../../assets/icons/backOffice/euroVat.svg';
import { lightTheme } from '../../../styles/GlobalStyles';

import { StakingHubDetails } from '../TravelPackages/TravelPackages';
import { USDT } from '../../../helpers/helperFunctions';

interface PaymentMethodProps {
  selectedPackage: any;
  userInfo: UserInfoType;
  handlePay: any;
  userAddress: UserAddress;
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
}

export const PaymentMethod = ({
  selectedPackage,
  userInfo,
  handlePay,
  userAddress,
  email,
  setEmail
}: PaymentMethodProps) => {
  const [checkbox, setCheckbox] = useState(false);

  const { t } = useTranslation('marketplace');

  if (!selectedPackage?.id) return null;

  const {
    id,
    imageUrl,
    name,
    price,
    totalPrice,
    weeklyCap,
    limitedQuantity,
    tradingBinaryPercentage,
    willyMemeCoins,
    subtitle,
    tickets,
    vatPercentage,
    vatPrice,
    feePrice,
    feePercentage
  } = selectedPackage;

  return (
    <div>
      <P1 bold mb={'20'}>
        {t('selected_staking_hub_nft')}:
      </P1>
      <Hub
        key={id}
        condensed
        image={imageUrl}
        title={name}
        price={price}
        subtitle={subtitle}
        tickets={tickets}
        packagePrice={price}
        vatPrice={vatPrice}
        feePrice={feePrice}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        willyMemeCoins={willyMemeCoins}
        info={<></>}
        stakingHubDetails={<StakingHubDetails hub={selectedPackage} />}
      />
      <P2 mb={'30'} mt={'40'}>
        Technology & Travel of the future is being built today. Position
        yourself as one of those who saw the change coming, before others didn’t
        even dare to dream.
      </P2>
      <P3 bold mb='8'>
        Payment Amount
      </P3>

      <InputBackOffice disabled value={totalPrice} icon={euroVat} />
      <Flexed between>
        <div>
          <CaptionText color={lightTheme.colors.neutral500}>
            VAT amount: {vatPrice} {USDT}
          </CaptionText>
          <CaptionText mb='20' color={lightTheme.colors.neutral500}>
            Payment gateway processing fee: {feePrice} {USDT}
          </CaptionText>
        </div>
        <div>
          <CaptionText color={lightTheme.colors.neutral500}>
            VAT percentage: {vatPercentage}%
          </CaptionText>
        </div>
      </Flexed>
      <P3 bold mb='8'>
        Payment Method
      </P3>
      <InputBackOffice disabled value={'Credit Card'} />
      <P3 bold mb='8'>
        Invoice to
      </P3>
      <InputBackOffice
        disabled
        value={`${userInfo?.user?.name} ${userInfo?.user?.surname}`}
      />
      <InputBackOffice
        disabled
        value={`${userAddress?.address}, ${userAddress?.city}, ${userAddress?.country}`}
      />
      <P3 bold mb='8'>
        Email
      </P3>
      <InputBackOffice
        placeholder='Enter your email address'
        value={email}
        onChange={setEmail}
      />
      {email?.length > 30 && (
        <CaptionText mb='20' color={lightTheme.colors.error500}>
          The payment provider requires an email address shorter than 30
          characters.
        </CaptionText>
      )}

      <CheckText
        checked={checkbox}
        onClick={() => setCheckbox(!checkbox)}
        text={`I hereby request immediate access to the Travelution digital service and acknowledge that I will lose my 14-day right of withdrawal once service delivery begins.`}
      />
      <Button
        mt={10}
        disabled={!checkbox || email === ''}
        onClick={() => {
          if (email.length > 30) {
            ErrorToast(
              'Payment provider requires email less than 30 characters'
            );
          } else {
            handlePay();
          }
        }}>
        Create Order
      </Button>
    </div>
  );
};
